const setWithTimeout = (method: Function, value: any, timeout = 300) => {
  setTimeout(() => {
    method(value)
  }, timeout)
}

export default setWithTimeout
